import React from "react";

import { Button } from "@material-ui/core";

import { useAppDispatch, useAppSelector } from "store";
import { chooseCandidateStoreByCostType } from "modules/customer/insights/cost/costSlice";
import { hideFilters, selectCandidateStore } from "modules/customer/insights/cost/filters/filtersSlice";

const Actions: React.FC = () => {
    const dispatch = useAppDispatch();
    const candidateStore = useAppSelector(selectCandidateStore);

    const handleFinishClick = () => {
        if (!candidateStore) {
            return;
        }
        dispatch(chooseCandidateStoreByCostType(candidateStore));
        dispatch(hideFilters());
    };

    return (
        <Button
            variant="contained"
            size="small"
            color="secondary"
            disableElevation
            onClick={handleFinishClick}
            disabled={(!candidateStore)}
            data-cy="btn-finish"
        >
            Finish
        </Button>
    );
};

export default Actions;
